import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  private toggleSidebar = new Subject<boolean>(); // small screen
  private toggleNotiSidebar = new Subject<boolean>();
  private isMobile = new BehaviorSubject<boolean>(window.innerWidth < 768);


  // Observable
  toggleSidebar$ = this.toggleSidebar.asObservable();
  toggleNotiSidebar$ = this.toggleNotiSidebar.asObservable();
  isMobile$ = this.isMobile.asObservable();

  toggleSidebarSmallScreen(toggle: boolean) {
    this.toggleSidebar.next(toggle);
  }

  toggleNotificationSidebar(toggle: boolean) {
    this.toggleNotiSidebar.next(toggle);
  }

  updateScreenSize(width: number) {
    this.isMobile.next(width < 768);
  }

}
